// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonObjectCreate/style.css
// module id = 3723
// module chunks = 29